<ng-container *ngIf="!publicProfile">
    <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="publicProfile">
    <h1>@{{publicProfile.username}}</h1>

    <div class="info">
        <div class="avatar" *ngIf="publicProfile.avatar" [responsiveBackgroundImage]="publicProfile.avatar"></div>
        <div>
            <div *ngIf="publicProfile.tagline">
                <em>{{publicProfile.tagline}}</em>
            </div>
            <a class="action-btn" (click)="hide()" routerLink="/community/profiles/{{publicProfile.username}}">
                View Profile
            </a>
            <a class="action-btn" href="javascript:;" (click)="showSpotHistory()">
                Comment History
            </a>
        </div>
    </div>
</ng-container>